import { models, Page, Report } from 'powerbi-client';

import React from 'react';
import DropdownField from '../../../../components/DropdownField';
import { appInsights } from '../../../../App';
import { VISUAL_IDS } from '../../../../constants/slicers';
import { useAuthStore } from '../../../../features/authentication';

const CompanyPicker = ({
  reportRef1,
  reportRef2,
  companyNames,
  setExternalSelected,
  selectedCompany,
}: {
  reportRef1: React.MutableRefObject<Report | null>;
  reportRef2: React.MutableRefObject<Report | null>;
  companyNames: string[];
  setExternalSelected: (name: string) => void;
  selectedCompany: string;
}) => {
  const { username } = useAuthStore();
  const updateMarket = async (name: string) => {
    setExternalSelected(name);

    updateDomainname(username);

    appInsights.trackEvent({
      name: 'ChooseCompany',
      properties: {
        name: name,
      },
    });

    if (!reportRef1.current || !reportRef2.current) {
      console.error('Report container not found.');
      return;
    }

    const report1 = reportRef1.current;
    const report2 = reportRef2.current;

    if (!report1 || !report2) {
      console.error('Report not found.');
      return;
    }

    const basicFilter: models.ISlicerFilter = {
      $schema: 'http://powerbi.com/product/schema#basic',
      filterType: 1,
      operator: 'In',
      requireSingleSelection: false,
      target: { table: 'market_unit_distribution', column: 'company' },
      values: [name],
    };

    try {
      const allPages = [...(await report1.getPages()), ...(await report2.getPages())];
      const activePages = allPages.filter((page: Page) => page.isActive);

      for (const page of activePages) {
        const visuals = await page.getVisuals();
        for (const visual of visuals) {
          if (visual.type === 'slicer') {
            try {
              if (visual.name === VISUAL_IDS.COMPANY.REPORT1 || visual.name === VISUAL_IDS.COMPANY.REPORT2) {
                try {
                  visual.setSlicerState({
                    filters: [basicFilter],
                  });
                } catch (error) {
                  console.error(error);
                }
              }
            } catch (error) {
              console.error('Error setting slicer state:', error);
            }
          }
        }
      }
    } catch (error) {
      console.error('Error setting company:', error);
    }
  };

  const updateDomainname = async (user: string) => {
    if (!reportRef1.current || !reportRef2.current) {
      console.error('Report container not found.');
      return;
    }

    const report1 = reportRef1.current;
    const report2 = reportRef2.current;
    if (!report1 || !report2) {
      console.error('Report not found.');
      return;
    }

    const basicFilter: models.ISlicerFilter = {
      $schema: 'http://powerbi.com/product/schema#basic',
      filterType: 1,
      operator: 'In',
      requireSingleSelection: false,
      target: { table: 'systemuser_partitioned', column: 'domainname' },
      values: [user],
    };

    try {
      const pages = [...(await report1.getPages()), ...(await report2.getPages())];
      const activePages = pages.filter((page: Page) => page.isActive);

      for (const page of activePages) {
        const visuals = await page.getVisuals();
        for (const visual of visuals) {
          if (
            visual.type === 'slicer' &&
            (visual.name === VISUAL_IDS.DOMAINNAME.REPORT1 || visual.name === VISUAL_IDS.DOMAINNAME.REPORT2)
          ) {
            try {
              visual.setSlicerState({
                filters: [basicFilter],
              });
            } catch (error) {
              console.error('Error setting slicer state:', error);
            }
          }
        }
      }
    } catch (error) {
      console.error('Error setting company:', error);
    }
  };

  return (
    <DropdownField
      values={companyNames}
      onUpdate={updateMarket}
      placeholder="Select company name"
      initialValue={selectedCompany}
    />
  );
};

export default CompanyPicker;
